import { giphyDarkGrey } from '@giphy/colors'
import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react'
import { ControlSize } from 'types'
import Icon from '../../../types/icons'
import { IconButtonProps } from '../icon-button'
import Content from './content'
import { Container, Header } from './style'

type Props = {
    buttonOptions?: Partial<IconButtonProps>
    children?: ReactNode
    className?: string
    color?: string
    defaultOpen?: boolean
    label?: ReactNode
    open?: boolean
    size?: ControlSize
    style?: CSSProperties
    onChange?: (isOpen: boolean) => void
    onTransitionEnd?: (isOpen: boolean) => void
    icon?: Icon
}

const Collapse = ({
    buttonOptions = {},
    children,
    className,
    color = giphyDarkGrey,
    defaultOpen = false,
    label,
    open: openProp,
    size = 'small',
    style,
    onChange,
    icon,
    onTransitionEnd: transitionEndProp,
}: Props) => {
    const initialValueRef = useRef<boolean | undefined>(openProp || defaultOpen)
    const [isOpen, setIsOpen] = useState<boolean>(openProp || defaultOpen)

    const onTransitionEnd = () => {
        transitionEndProp?.(isOpen)
    }

    useEffect(() => {
        if (typeof openProp !== 'undefined' && openProp !== isOpen) {
            setIsOpen(openProp)
        }
    }, [openProp])

    useEffect(() => {
        if (isOpen !== initialValueRef.current) {
            initialValueRef.current = undefined
            onChange?.(isOpen)
        }
    }, [isOpen])

    return (
        <Container className={className} controlSize={size} style={style}>
            <Header
                buttonOptions={buttonOptions}
                controlColor={color}
                isOpen={isOpen}
                label={label}
                size={size}
                onToggle={setIsOpen}
                icon={icon}
            />
            <Content isOpen={isOpen} onTransitionEnd={onTransitionEnd}>
                {children}
            </Content>
        </Container>
    )
}

export default Collapse
